
export class TS_TC {
  title: string;
  url: string;
}
